import { Chakra } from "@airhelp/react-ui-components";
import type { ChakraProps } from "@chakra-ui/react";
import type { ReactNode } from "react";

const { Box } = Chakra;

const customClassNames: Record<string, ChakraProps["sx"]> = {
  ".white": {
    color: "white",
  },
  ".brandBlueFont": {
    color: "primary.500",
  },
  ".brandingDark": {
    color: "greyscale.500",
  },
  ".greyscale700": {
    color: "greyscale.700",
  },
  ".medium": {
    fontSize: "md",
    lineHeight: "base",
    display: "inline-block",
  },
};

const Styled = ({ children, className }: { children: ReactNode; className: string }) => (
  <Box sx={customClassNames} as="span">
    <Box as="span" className={className}>
      {children}
    </Box>
  </Box>
);

export default Styled;
